import angular from 'angular';
import 'angular-jwt';
import '../app.constants';
import '../services/auth';
import '../services/user';
import '../services/globals';
import '../services/errors';
import { localStorage } from '../utils';

const module = angular.module('whyline.controllers.onelogin', [
  'angular-jwt',
  'whyline.constants',
  'whyline.services.auth',
  'whyline.services.user',
  'whyline.services.globals',
  'whyline.services.errors',
]);

const OneLoginController = (
  SAFE_STATES,
  $scope,
  jwtHelper,
  $state,
  AuthService,
  GlobalsService,
  ErrorService,
  $translate,
  $timeout,
  blockUI,
) => {
  /*@ngInject*/

  $scope.message = null;

  // Enterprise type for branding
  $scope.enterpriseType = GlobalsService.EnterpriseType;
  $scope.currentYear = new Date().getFullYear();
  $scope.currentLanguage = $translate.use();

  let jwtToken = localStorage.get('token');
  if (jwtToken && !jwtHelper.isTokenExpired(jwtToken)) {
    $scope.message = 'Abriendo aplicación...';

    $timeout(() => {
      return $state.go(SAFE_STATES.organizationsList);
    }, 1000);
  }

  blockUI.start('Recuperando información...');

  $timeout(() => {
    const token = $state.params.token;

    if (!token) {
      return $state.go(SAFE_STATES.signIn);
    }

    AuthService.OneLogin(token)
      .then((data) => {
        $scope.message = 'Abriendo aplicación...';

        $timeout(() => {
          if (data.user.sigeci) {
            $state.go(SAFE_STATES.appointments);
          }
          $state.go(SAFE_STATES.organizationsList);
        }, 1000);
      })
      .catch((err) => {
        console.log('onelogin error =>', err);

        const {
          data: { error },
        } = err;

        if (error === 'user-waiting-confirmation') {
          $scope.message =
            'Tu cuenta está pendiente de confirmación, comunícate con el administrador del sistema.';
        } else if (error === 'user-does-not-have-access') {
          $scope.message =
            'Tu cuenta no tiene los permisos correspondientes para utilizar esta aplicación, comunícate con el administrador del sistema.';
        } else {
          $scope.message =
            'Ocurrió un error inesperado, comunícate con el administrador de sistema.';
        }
      })
      .finally(() => {
        blockUI.stop();
      });
  });
};

module.exports = module.controller('OneLoginController', OneLoginController);
